import excursionApi from "@/services/api/Excursion";
import { ExcursionUpdateDTO } from "@/services/api/Excursion/dtos";
import IExcursion from "@/services/api/Excursion/IExcursion";
import { ExcursionStatus } from "@/types/types";
import {
  deleteImageFromFirebase,
  uploadOriginalAndPreviewImagesToFirebase,
} from "@/utils/firebase/functions";
import { getExcursionsFirebasePath } from "@/utils/stringUtils";

export const handleUpdateExcursion = async (
  excursionId: string,
  excursionUpdateDto: ExcursionUpdateDTO,
  updatedOriginalImageArray: string[],
  updatedPreviewImageArray: string[],
  storeName: string,
  storeId: string
) => {
  for (let i = 0; i < excursionUpdateDto.imageOriginal.length; i++)
    !updatedOriginalImageArray.includes(excursionUpdateDto.imageOriginal[i]) &&
      (await Promise.all([
        deleteImageFromFirebase(excursionUpdateDto.imageOriginal[i]),
        deleteImageFromFirebase(excursionUpdateDto.imagePreview[i]),
      ]));

  let finalOriginalImages = updatedOriginalImageArray;
  let finalPreviewImages = updatedPreviewImageArray;

  if (excursionUpdateDto.images.length > 0) {
    const uploadedImagesResponse =
      await uploadOriginalAndPreviewImagesToFirebase(
        excursionUpdateDto.images,
        getExcursionsFirebasePath(
          storeName,
          storeId,
          excursionUpdateDto?.title,
          excursionId
        )
      );

    finalOriginalImages.push(...uploadedImagesResponse.originalImageUrls);
    finalPreviewImages.push(...uploadedImagesResponse.previewImageUrls);
  }

  const updatedExcursion: IExcursion = {
    title: excursionUpdateDto.title,
    price: excursionUpdateDto.price,
    mainCategory: excursionUpdateDto.mainCategory,
    agent: excursionUpdateDto.agent,
    startDate: excursionUpdateDto.startDate,
    endDate: excursionUpdateDto.endDate,
    minVacancies: excursionUpdateDto.minVacancies,
    maxVacancies: excursionUpdateDto.maxVacancies,
    description: excursionUpdateDto.description,
    router: excursionUpdateDto.router,
    transportService: excursionUpdateDto.transportService,
    accommodationService: excursionUpdateDto.accommodationService,
    foodService: excursionUpdateDto.foodService,
    excursionContract: excursionUpdateDto.excursionContract,
    groupLink: excursionUpdateDto.groupLink,
    city: excursionUpdateDto.city,
    state: excursionUpdateDto.state,
    region: excursionUpdateDto.region,
    country: excursionUpdateDto.country,
    imageOriginal: finalOriginalImages,
    imagePreview: finalPreviewImages,
    excursionStatus: ExcursionStatus.ACTIVE,
  };

  const updatedExcursionResponse = await excursionApi.updateExcursion(
    excursionId,
    updatedExcursion
  );

  return updatedExcursionResponse;
};
